import { render, staticRenderFns } from "./destinations.vue?vue&type=template&id=5a601896&scoped=true&"
import script from "./destinations.vue?vue&type=script&lang=js&"
export * from "./destinations.vue?vue&type=script&lang=js&"
import style0 from "./destinations.vue?vue&type=style&index=0&id=5a601896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a601896",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a601896')) {
      api.createRecord('5a601896', component.options)
    } else {
      api.reload('5a601896', component.options)
    }
    module.hot.accept("./destinations.vue?vue&type=template&id=5a601896&scoped=true&", function () {
      api.rerender('5a601896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/destinations.vue"
export default component.exports